import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  id: "associator-container",
  class: "p-grid p-m-2"
}
const _hoisted_2 = {
  id: "source-list-container",
  class: "p-col p-d-flex p-flex-column kn-flex"
}
const _hoisted_3 = { class: "kn-relative kn-flex" }
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "pi pi-bars" }, null, -1)
const _hoisted_5 = { class: "kn-list-item-text" }
const _hoisted_6 = {
  id: "target-list-container",
  class: "p-col p-d-flex p-flex-column kn-flex"
}
const _hoisted_7 = { class: "kn-relative kn-flex" }
const _hoisted_8 = { class: "associator-block-hover p-d-flex p-flex-row p-ai-center kn-width-full" }
const _hoisted_9 = { class: "kn-truncated kn-flex-05" }
const _hoisted_10 = {
  key: 0,
  class: "fas fa-link kn-flex-05"
}
const _hoisted_11 = { class: "kn-truncated" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Listbox = _resolveComponent("Listbox")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('metaweb.businessModel.sourceAttr')), 1)
        ]),
        _: 1
      }),
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_Listbox, {
          class: "associator-list kn-list data-condition-list kn-absolute kn-height-full kn-width-full",
          options: _ctx.sourceModel
        }, {
          empty: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('metaweb.businessModel.sourceHint')), 1)
          ]),
          option: _withCtx((slotProps) => [
            _createVNode("div", {
              id: 'source-' + slotProps.index,
              ref: 'source-' + slotProps.index,
              class: "kn-list-item kn-draggable",
              draggable: "true",
              onDragstart: ($event: any) => (_ctx.onDragStart($event, 'source-' + slotProps.index)),
              onDragend: ($event: any) => (_ctx.removeDragClass('source-' + slotProps.index))
            }, [
              _hoisted_4,
              _createVNode("div", _hoisted_5, [
                _createVNode("span", null, _toDisplayString(slotProps.option.name), 1)
              ])
            ], 40, ["id", "onDragstart", "onDragend"])
          ]),
          _: 1
        }, 8, ["options"])
      ])
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('metaweb.businessModel.targetAttr')), 1)
        ]),
        _: 1
      }),
      _createVNode("div", _hoisted_7, [
        _createVNode(_component_Listbox, {
          class: "associator-list kn-list data-condition-list kn-absolute kn-height-full kn-width-full",
          options: _ctx.targetModel
        }, {
          empty: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('metaweb.businessModel.targetHint')), 1)
          ]),
          option: _withCtx((slotProps) => [
            _createVNode("div", {
              class: "associator-target-list-item",
              id: 'target-' + slotProps.index,
              ref: 'target-' + slotProps.index,
              onDrop: ($event: any) => (_ctx.onDrop($event, 'target-' + slotProps.index, slotProps.option)),
              onDragover: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
              onDragenter: _withModifiers(($event: any) => (_ctx.setDropzoneClass(true, 'target-' + slotProps.index)), ["prevent"]),
              onDragleave: _withModifiers(($event: any) => (_ctx.setDropzoneClass(false, 'target-' + slotProps.index)), ["prevent"])
            }, [
              _createVNode("div", _hoisted_8, [
                _createVNode("span", _hoisted_9, _toDisplayString(slotProps.option.name), 1),
                (slotProps.option[_ctx.associatedItem] && slotProps.option[_ctx.associatedItem].length > 0)
                  ? (_openBlock(), _createBlock("i", _hoisted_10))
                  : _createCommentVNode("", true),
                (slotProps.option[_ctx.associatedItem] && slotProps.option[_ctx.associatedItem].length > 0)
                  ? (_openBlock(), _createBlock("div", {
                      key: 1,
                      class: ["p-d-flex p-flex-column kn-flex", { 'p-mb-1': slotProps.option[_ctx.associatedItem].length > 1 }]
                    }, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(slotProps.option[_ctx.associatedItem], (link, index) => {
                        return (_openBlock(), _createBlock("span", {
                          class: "p-d-flex p-flex-row p-ai-center",
                          key: index
                        }, [
                          _createVNode("span", _hoisted_11, _toDisplayString(link.name), 1),
                          (slotProps.option[_ctx.associatedItem].length > 1)
                            ? (_openBlock(), _createBlock(_component_Button, {
                                key: 0,
                                icon: "fas fa-times",
                                class: "associator-enable-hover p-button-text p-button-rounded p-button-plain",
                                onClick: _withModifiers(($event: any) => (_ctx.deleteRelationship(slotProps.option, link)), ["stop"])
                              }, null, 8, ["onClick"]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ], 2))
                  : _createCommentVNode("", true),
                (slotProps.option[_ctx.associatedItem] && slotProps.option[_ctx.associatedItem].length > 0)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 2,
                      icon: "far fa-trash-alt kn-flex-0",
                      class: "associator-enable-hover p-button-text p-button-rounded p-button-plain",
                      onClick: _withModifiers(($event: any) => (_ctx.deleteRelationship(slotProps.option)), ["stop"])
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ])
            ], 40, ["id", "onDrop", "onDragenter", "onDragleave"])
          ]),
          _: 1
        }, 8, ["options"])
      ])
    ])
  ]))
}